import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { fetchRoles } from '../../../redux/actions/userDetailsActions';
import { AppRoles } from '../../../interfaces/authorizationInterfaces';
import LoadingSpinner from '../../loaders/combinedHeaderAndSpinner';
import AuthService from '../../../services/authService';
import { publicRoutes } from '../../../routes/appRouteList';

interface AuthorizeProps {
    hasFetchedRoles: boolean;
    roles: AppRoles;
    fetchRolesAction: Function;
    homeRoute: string;
}

const Authorize: React.FC<AuthorizeProps> = (props: AuthorizeProps): JSX.Element => {
    const history = useHistory();

    const { fetchRolesAction } = props;

    useEffect(() => {
        AuthService.authorize().then(() => {
            fetchRolesAction();
        }, () => {
            history.push(publicRoutes.notAuthorized);
        });
    }, [fetchRolesAction, history]);

    useEffect(() => {
        if (props.hasFetchedRoles === true) {
            if (props.roles.marketInsights) {
                document.title = 'Market Insights';
            }
            history.push(props.homeRoute);
        }
    }, [props.hasFetchedRoles, props.roles, history, props.homeRoute]);

    return <LoadingSpinner />;
};

const mapStateToProps = (state: any): object => {
    return {
        roles: state.userDetails.roles,
        hasFetchedRoles: state.userDetails.hasFetchedRoles,
        homeRoute: state.userDetails.homeRoute
    };
};

const mapDispatchToProps = {
    fetchRolesAction: fetchRoles
};

const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any): object => {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Authorize);
